import React, { useEffect, useState } from "react";

import {

    Box,
    Typography,
    Paper,
    Alert,
    Button

} from "@mui/material";

import RefreshIcon from "@mui/icons-material/Refresh";

import KnowledgeGrid from "../components/knowledge/KnowledgeGrid";
import LoadingState from "../components/knowledge/LoadingState";

import knowledgeAPI from "../api/knowledge";

export default function Knowledge() {

    const [knowledge, setKnowledge] = useState([]);

    const [loading, setLoading] = useState(true);

    const [error, setError] = useState("");

    const loadKnowledge = async () => {

        try {

            setLoading(true);

            const data =
                await knowledgeAPI.getAll();

            setKnowledge(data);

            setError("");

        }

        catch (err) {

            console.error(err);

            setError("Unable to load the Knowledge Repository.");
            console.error("Knowledge fetch error:", err);

        }

        finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        loadKnowledge();

    }, []);

    if (loading) {

        return <LoadingState />;

    }

    return (

        <Box>

            <Paper
                elevation={2}
                sx={{
                    p: 3,
                    mb: 3
                }}
            >

                <Box

                    display="flex"

                    justifyContent="space-between"

                    alignItems="center"

                >

                    <Box>

                        <Typography
                            variant="h4"
                            fontWeight="bold"
                        >

                            Knowledge Repository

                        </Typography>

                        <Typography
                            color="text.secondary"
                        >

                            Browse all synchronized knowledge from Google Drive.

                        </Typography>

                    </Box>

                    <Button

                        variant="contained"

                        startIcon={<RefreshIcon />}

                        onClick={loadKnowledge}

                    >

                        Refresh

                    </Button>

                </Box>

            </Paper>

            {

                error &&

                <Alert
                    severity="error"
                    sx={{ mb: 3 }}
                >

                    {error}

                </Alert>

            }

            <KnowledgeGrid

                items={knowledge}

            />

        </Box>

    );

}